export class BasketError extends Error {
	constructor(message?: string) {
		super(message);

		this.name = 'BasketError';
	}
}
